import loadable from '@loadable/component';

export const SearchOrgsRefinementsLoadable = loadable(
  () => import('./SearchOrgsRefinements'),
  { resolveComponent: (module) => module.SearchOrgsRefinements },
);
